import get from 'lodash.get'
import trackPageGTM from './trackPageGTM'
import trackEventGTM from './trackEventGTM'

export const getPageName = (pageKey) => {
  return pageKey.match(/[a-z]+-(.+)/)[1].replace(/-/g, ' ')
}
export class Analytics {
  constructor({ brand }) {
    this.brand = brand
  }

  trackEvent(data) {
    const eventData = { ...data }

    if (get(eventData, 'eventInfo')) {
      eventData.event = data.eventInfo.eventName
      eventData.effect = data.eventInfo.effect
      delete eventData.eventInfo
    }

    trackEventGTM(eventData)
  }

  trackPage(headAnalyticsData, locale, deviceType, listing) {
    trackPageGTM(headAnalyticsData, locale, this.brand, deviceType, listing)
  }
}
